import { AppSettings } from './../app.settings';
import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { Observable } from 'rxjs';

@Injectable()
export class NotificationsService {
  canFetchNotification = false;
  constructor(private restApiService: RestApiService) { }


  getDetails(limit, offset): Observable<any> {
    return this.restApiService.get('', '/secure/users/notification?offset=' + offset + '&limit=' + limit, 'page-center');
  }

  getCount(): Observable<any> {
    return this.restApiService.get('public', '/secure/notification/unreadcount', 'page-center');
  }

  getNotificationCount(userId): Observable<any> {
    return this.restApiService.get('public', `/secure/users/${userId}/notifications/unreadcount`, 'page-center');
  }

  startFetchingNotifications(callback) {
    AppSettings.CLEAR_NOTIFICATION_INTERVAL = setInterval(() => {
      if (this.canFetchNotification) {
        callback();
      }
    }, AppSettings.NOTIFICATION_INTERVAL);
  }

  stopFetchingNotifications() {
    if (AppSettings.CLEAR_NOTIFICATION_INTERVAL) {
      clearInterval(AppSettings.CLEAR_NOTIFICATION_INTERVAL);
    }
  }

  getShiftManagerDetails(notesType): Observable<any> {
    return this.restApiService.get('', '/secure/shift-manager-notes?notesType=' + notesType, 'page-center');
  }

  setShiftManagerDetails(data): Observable<any> {
    return this.restApiService.post('', '/secure/shift-manager-notes', data, 'page-center');
  }

  deleteShiftManagerDetails(notesType): Observable<any> {
    return this.restApiService.delete('', '/secure/shift-manager-notes?notesType=' + notesType, 'page-center');
  }

}
